import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Spinner,
  Modal,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios";
import { useCart } from "../context/CartContext";

const API_URL = "https://apimyshop.myidealtd.co.uk";

function NewArrivals() {
  const { addToCart, cart } = useCart();

  const safeCart = Array.isArray(cart) ? cart : [];

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [quickView, setQuickView] = useState(null);


  /* ================= IMAGE HANDLER ================= */

const API_BASE = "https://apimyshop.myidealtd.co.uk";

const getImageUrl = (product) => {
  if (!product) return "/images/no-image.png";

  // Same structure as Products.js
  if (
    product.images &&
    product.images.length > 0 &&
    product.images[0].main
  ) {
    return `${API_BASE}${product.images[0].main}`;
  }

  return "/images/no-image.png";
};

  /* ================= LOAD PRODUCTS ================= */

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await axios.get(`${API_URL}/api/products`);

        console.log("FULL API RESPONSE:", res.data);

    

        const allProducts =
            Array.isArray(res.data)
              ? res.data
              : res.data.products || [];

        console.log("ALL PRODUCTS:", allProducts);



        const arrivals = allProducts.filter((p) => {

          return (
            p.newArrival === true ||
            p.newArrival === "true" ||
            p.features?.newArrival === true ||
            p.features?.newArrival === "true"
          );

        });

        console.log("NEW ARRIVALS:", arrivals);

        setProducts(arrivals);
      } catch (err) {
        console.error("Axios Error:", err);

        if (err.response) {
          console.log("Status:", err.response.status);
          console.log("Data:", err.response.data);
        }

        setError("Failed to load New Arrival products.");
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  /* ================= ADD TO CART ================= */

  const handleAdd = (product) => {
    if (safeCart.some((item) => item._id === product._id)) return;
    addToCart(product);
  };

  /* ================= LOADING ================= */

  if (loading) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Spinner animation="border" />
      </div>
    );
  }

  return (
    <Container fluid className="py-5">
      <div className="text-center mb-5">
        <div
          style={{
            display: "inline-block",
            padding: "8px 20px",
            borderRadius: "999px",
            background: "linear-gradient(135deg,#2563eb,#3b82f6)",
            color: "#fff",
            fontWeight: 700,
          }}
        >
          🆕 NEW ARRIVALS
        </div>

        <h1 className="mt-4 fw-bold">New Arrivals</h1>

        <p className="text-muted">
          Discover the latest products added to our store.
        </p>
      </div>

      <Row className="g-4">
        {products.map((p) => (
          <Col lg={3} md={6} key={p._id}>
            <Card
              style={{
                border: "none",
                borderRadius: "25px",
                overflow: "hidden",
                height: "100%",
                boxShadow: "0 10px 30px rgba(0,0,0,.10)",
              }}
            >
              <div style={{ position: "relative" }}>
                <div
                  style={{
                    position: "absolute",
                    top: "15px",
                    left: "15px",
                    zIndex: 2,
                    background: "#2563eb",
                    color: "#fff",
                    padding: "7px 15px",
                    borderRadius: "999px",
                    fontWeight: 700,
                    fontSize: "12px",
                  }}
                >
                  NEW
                </div>

                <Link to={`/product/${p._id}`}>
                  <img
                    src={getImageUrl(p)}
                    onError={(e) => {
                        console.log("Broken image:", getImageUrl(p));
                        e.target.src = "/images/no-image.png";
                    }}
                    alt={p.name}
                    style={{
                      width: "100%",
                      height: "260px",
                      objectFit: "contain",
                      padding: "20px",
                      background: "#f8fafc",
                    }}
                  />
                </Link>
              </div>

              <Card.Body>
                <h5>{p.name}</h5>

                <h4 style={{ color: "#2563eb" }}>£{p.price}</h4>

                <Button
                  className="w-100"
                  onClick={() => handleAdd(p)}
                >
                  Add to Cart
                </Button>

                <Button
                  variant="light"
                  className="w-100 mt-2"
                  onClick={() => setQuickView(p)}
                >
                  Quick View
                </Button>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      {products.length === 0 && (
        <div className="text-center mt-5">
          <h3>No New Arrival products found</h3>
        </div>
      )}

      {error && (
        <div className="text-center mt-3 text-danger">
          {error}
        </div>
      )}

      <Modal
        show={!!quickView}
        onHide={() => setQuickView(null)}
        centered
      >
        {quickView && (
          <>
            <Modal.Header closeButton>
              <Modal.Title>{quickView.name}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <img
                src={getImageUrl(quickView)}
                alt={quickView.name}
                style={{
                  width: "100%",
                  borderRadius: "20px",
                }}
              />

              <h3 className="mt-3">£{quickView.price}</h3>

              <p>{quickView.description}</p>
            </Modal.Body>
          </>
        )}
      </Modal>
    </Container>
  );
}

export default NewArrivals;